module.exports = __webpack_public_path__ + "img/bg-768.3aaf9624.webp";